import { useButtonDefinitions } from 'components/eventView/overview/useButtonDefinitions';
import { EventEntityDefinition } from 'components/eventView/pages/eventData';
import { TileButton } from 'elements/eventView/atomic/TileButton';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OverviewButtonsV2 = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const buttonDefinitions = useButtonDefinitions();

    const rowsAndCols = ctxEventView.eventData.eventInfo.order?.normalV2;

    function getButton(nameOrId: string, opts: { isNarrow: boolean }) {
        if (ctxEventView.eventData.eventInfo.homepageContent?.[nameOrId]) {
            return ctxEventView.eventData.eventInfo.homepageContent?.[nameOrId]?.();
        }

        if (nameOrId === 'information') {
            return (
                <TileButton
                    key={nameOrId}
                    {...buttonDefinitions.information}
                    narrowStyle={opts.isNarrow}
                />
            );
        } else if (nameOrId === 'program') {
            return (
                <TileButton
                    key={nameOrId}
                    {...buttonDefinitions.programme}
                    narrowStyle={opts.isNarrow}
                />
            );
        }

        const otherEntityDefinition: EventEntityDefinition =
            ctxEventView.otherEntityDefinitions.find((otherEntity) => nameOrId === otherEntity.id);
        if (otherEntityDefinition) {
            return (
                <TileButton
                    key={nameOrId}
                    {...buttonDefinitions.getOtherEntity(otherEntityDefinition)}
                    narrowStyle={opts.isNarrow}
                />
            );
        }

        if (nameOrId === 'map') {
            return (
                <TileButton
                    key={nameOrId}
                    {...buttonDefinitions.map}
                    title={Localization.MAP}
                    narrowStyle={opts.isNarrow}
                />
            );
        }
    }

    return (
        <S_OverviewButtonsV2 className={props.className}>
            {rowsAndCols?.map((row) => {
                // eslint-disable-next-line react/no-array-index-key
                return (
                    <S_Row key={row.join(';')} $cols={Math.min(row.length, 3)}>
                        {row.map((nameOrId) => {
                            const button = getButton(nameOrId, { isNarrow: row.length >= 3 });
                            return button;
                        })}
                    </S_Row>
                );
            })}
        </S_OverviewButtonsV2>
    );
};

const S_OverviewButtonsV2 = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;
const S_Row = styled.div<{ $cols: number }>`
    width: 100%;
    display: grid;
    grid-template-columns: ${(props) => `repeat(${props.$cols}, minmax(0, 1fr))`};
    gap: 15px;
`;
